// extracted by mini-css-extract-plugin
export var facebook = "libSocials-module--facebook--ec1a7";
export var icon = "libSocials-module--icon--075d9";
export var instagram = "libSocials-module--instagram--c92d8";
export var news = "libSocials-module--news--56a23";
export var twitter = "libSocials-module--twitter--115ae";
export var ug_socials = "libSocials-module--ug_socials--adafa";
export var youtube = "libSocials-module--youtube--14390";